import React from 'react';
import PropTypes from 'prop-types';
import { BlockVariation, ContentContainerWrapper } from './ContentContainer.styles';

export default function ContentContainer({ children, ...props }) {
    return (
        <ContentContainerWrapper>
            <BlockVariation {...props}>{children}</BlockVariation>
        </ContentContainerWrapper>
    );
}

ContentContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

ContentContainer.splash = {
    ...BlockVariation.splash,
    defaultProps: {
        ...BlockVariation.splash.defaultProps,
    },
};
